import {Box,Button,Checkbox, FormControl,FormControlLabel,FormGroup , FormHelperText, Grid, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { Controller,useForm } from 'react-hook-form'
import Swal from 'sweetalert2';
import { BookingService } from '../Service';
import { BookingDataContext, StepperDataContext } from './UpdateBooking';
import { useParams } from 'react-router-dom';

const Payment = () => {
    const {id} = useParams();
    const {bookingInitiationData,dateTimeSlot,finalBookingCalculation,setBookingInitiationData,chargeDetails,paymentDetails,setPaymentDetails} = useContext(BookingDataContext);
    const {activeStep, setActiveStep,completed, setCompleted,handleNext,handleBack,handleComplete,handleReset,bookingResponseDetails,setBookingResponseDetails} = useContext(StepperDataContext);
    const { control, handleSubmit, setValue, formState: { errors ,isDirty},watch,reset } = useForm({
        mode: "onChange",
        defaultValues:{
            paymentMode:paymentDetails.paymentMode||'',
        }
    });
    // const getFullAddress = () => {
    //     const addressParts = [
    //       bookingInitiationData.houseFlatBlockNo,
    //       bookingInitiationData.apartmentRoadArea,
    //       // bookingInitiationData.address,
    //       bookingInitiationData.landmark,
    //       bookingInitiationData.city,
    //       bookingInitiationData.state,
    //       bookingInitiationData.pincode
    //     ];
      
    //     // Filter out empty or undefined parts and join with a comma
    //     return addressParts
    //       .filter(part => part && part.trim() !== '')
    //       .join(', ');
    // };
    const completeBooking=async()=>{
        // console.log(" submitted Schedule and Address:",data);
        const result = await Swal.fire({
          text: "Do you want to Confirm Booking now?",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Confirm now!',
          cancelButtonText: 'No, Cancel',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: false,
        });
        if (result.isConfirmed){
          let subTotal =0;
          const items = bookingInitiationData?.services.map((service)=>{
            subTotal = parseFloat(subTotal)+parseFloat(service.price * service.quantity);
            return {
              providerServiceId: service.id,
              quantity:service.quantity,
            }
          });
          const timeJson = JSON.parse(dateTimeSlot?.timeSlot);
        //   const fullAddress = getFullAddress();
          const formattedDatatobeSend = {
            customerId: bookingInitiationData?.customer.id,
            providerId: bookingInitiationData?.serviceExpert,
            paymentId: 1,
            serviceDate: dateTimeSlot?.serviceDate,
            bookingStartTime: timeJson.startTime,
            bookingEndTime: timeJson.endTime,
            subTotal: parseFloat(finalBookingCalculation.subTotal).toFixed(2),
            coinValue:finalBookingCalculation?.coinValue || 0,
            couponId: chargeDetails?.couponId || 0,
            couponAmount: chargeDetails?.couponAmount || 0,
            discount: chargeDetails?.discount || 0,
            platformCharges: chargeDetails?.platformCharges || 0,
            total: parseFloat(finalBookingCalculation.total).toFixed(2),  
            callbackRequest: true,
            add_customerFullName: `${bookingInitiationData?.customer.profile.firstName} ${bookingInitiationData?.customer.profile.middleName} ${bookingInitiationData?.customer.profile.lastName}`,
            add_mobileNumber: bookingInitiationData?.customer.mobileNumber,
            add_pincode: bookingInitiationData?.pincode,
            add_latitude: bookingInitiationData?.latitude,
            add_longitude: bookingInitiationData?.longitude,
            add_city: bookingInitiationData?.city,
            add_state: bookingInitiationData?.state,
            add_landmark: bookingInitiationData?.landmark||'',
            add_address: bookingInitiationData?.address,
            items: items,
          }
    
          if(id>0){
            console.log("booking updated Data:",formattedDatatobeSend)
          }else{            
            console.log("data to be send for new booking:",formattedDatatobeSend);
            try {
                // Show loading state
                Swal.fire({
                    title: 'Processing...',
                    text: 'Please wait while we processing your booking request',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
        
                // Make the API call
                const bookingResponse = await BookingService.addBooking(formattedDatatobeSend);
                // console.log("new booking Response:",bookingResponse);
        
                // Close loading dialog and show success/error message
                if (bookingResponse.success === 1) {
                // await fetchProviderServiceList({
                //   providerId:serviceDetailsData.providerId,
                //   page:controller.page+1, 
                //   pageSize:controller.pageSize,
                // }); 
                setBookingResponseDetails({status:'true',message:'booking successfull',data:bookingResponse.data})
                await Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: bookingResponse.message || 'Service Booking successfull',
                    timer: 1500
                });
                handleComplete();
                handleNext();
                return true;
                } else {
                    await Swal.fire({
                        icon: 'error',
                        title: 'Error!',
                        text: 'Something Went Wrong ... Booking failed'
                    });
                    return false;
                }
        
            } catch (error) {
                // console.error("Error in Booking:", error);
                await Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'An error occurred while booking'
                });
                return false;
            }
          }
        }else {
          return false;
        }
      }
  return (
    <Box component={'form'} onSubmit={handleSubmit(completeBooking)} sx={{pb:'1%'}}>
        <Grid container spacing={2} >
            <Grid item lg={9} xs={12} sx={{margin:'auto'}}>
                <Grid container spacing={2} >
                {/* ............left section................... */}
                    <Grid item xs={12} lg={5}>
                        <Grid container>
                            <Grid item xs={12} sx={{my:'1%'}}>
                                <Grid container sx={{mb:'1%'}}>
                                    <Grid item lg={7} xs={12}>
                                        <Typography sx={{fontWeight:'600'}}>Payment Method :</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item lg={12} xs={12}>
                                    <Controller
                                        name="paymentMode"
                                        control={control}
                                        rules={{ required: "Please select paymentMode" }}
                                        render={({ field, fieldState: { error } }) => (
                                            <FormControl sx={{ minWidth: "100%" }} component="fieldset" error={!!error}>
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={field.value === 'pay after service'}
                                                                onChange={(e) => {
                                                                    // If checkbox is checked, set to 'pay after service'
                                                                    // If unchecked, set to empty string
                                                                    const newValue = e.target.checked ? 'pay after service' : '';
                                                                    field.onChange(newValue);
                                                                    setValue('paymentMode', newValue);
                                                                }}
                                                            />
                                                        }
                                                        label="Pay After Service"
                                                    />
                                                </FormGroup>
                                                {error && <FormHelperText>{error.message}</FormHelperText>}
                                            </FormControl>
                                        )}
                                    />

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        {/* =======Form Action Button Section ========*/}
        <Box sx={{display:'flex',justifyContent:'center',gap:2,mt:'.5%'}}>
            <Button disabled={activeStep === 0} onClick={handleBack} variant='contained' color='secondary'>Back</Button>
            <Button 
                disabled={!watch('paymentMode') || !isDirty} 
                type='submit' 
                // onClick={handleNext}
                variant='contained' color='primary'
            >
                {/* Submit & Next */}
                confirm Booking
            </Button>
        </Box>
    </Box>
  );
}

export default Payment;
